// noinspection ES6UnusedImports
import Chart from 'chart.js';

import ProfileMenu from './partials/profileMenu.js';
import NotificationDropdown from './partials/notificationDropdown.js';
import Tooltips from './partials/tooltips.js';
import ClampText from './partials/clampText.js';

$(() => {
    ProfileMenu.init();
    NotificationDropdown.init();
    Tooltips.init();
    ClampText.init();

    // Login/Register functionality
    $('#submitButton').click(function () {
        $('form.auth').submit();
    });
    $('form.auth').on('submit', function () {
        $('#loginForm').slideUp();
        $('#recoverForm').fadeIn();
    });

    // Sidebar functionality
    $('#sidebar .menuCollapse').each((i, e) => {
        const item = $(e);
        if (item.children('a').hasClass('active')) {
            item.addClass('show');
        }
    });

    let dashboardSidebar = (function () {

        let sidebar = $('#sidebar');
        let toggleSidebar = $('#toggleSidebar');
        let toggleSidebarDesktop = $('#toggleSidebarDesktop');

        let open = function () {
            $('body').addClass('sidebar-expanded');
            sidebar.addClass('expanded');
            sidebar.removeClass('minified');
        };

        let close = function () {
            $('body').removeClass('sidebar-expanded');
            sidebar.removeClass('expanded');
            sidebar.addClass('minified');
            $('#sidebar .collapse').each(function () {
                $(this).collapse('hide');
            });
        };

        let toggle = function () {
            localStorage.sidebarStatus = !(localStorage.sidebarStatus === 'true');
            updateSidebar();
        };

        let updateSidebar = function (firstLoad) {
            if (localStorage.sidebarStatus === 'true') {
                if (window.innerWidth < 800) {
                    if (firstLoad === true) {
                        close();
                    } else {
                        open();
                    }
                } else {
                    open();
                }
            } else {
                close();
            }
        };

        let init = function () {
            if (!localStorage.sidebarStatus) {
                localStorage.sidebarStatus = window.innerWidth < 800 ? 'false' : 'true';
            }

            toggleSidebar.on('click', toggle);
            toggleSidebarDesktop.on('click', toggle);
            updateSidebar(true);

            $('#sidebar .dropdown-toggle').parent().click(function () {
                if (localStorage.sidebarStatus === 'false') {
                    toggle();
                }
            });

        };

        return {
            init: init,
        };

    }());
    dashboardSidebar.init();
});
// END: Doc ready
